export const BEIAN_TEXT = process.env.BEIAN_TEXT || '京ICP备14008635号-3';
export const BEIAN_URL = process.env.BEIAN_URL || 'https://beian.miit.gov.cn';
export const BEIAN_COPYRIGHT_TEXT = `© 2026 · ${BEIAN_TEXT}`;
